__turbopack_context__.v({
  "root": "MobileRecoveryComponent-module__P-o5RG__root",
});
